import { Shield, FileText, Users, Lock, Mail, Trash2 } from "lucide-react";

const Privacy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-slate-900 py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-sm font-semibold tracking-[0.1em] uppercase text-slate-400 mb-4 block">
              Informativa
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tighter text-white mb-4">
              Privacy Policy
            </h1>
            <p className="text-lg text-slate-300">
              Informativa sul trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR)
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            {/* Titolare */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <Shield className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  Titolare del Trattamento
                </h2>
              </div>
              <p className="text-slate-600 ml-13">
                Il Titolare del trattamento dei dati è <strong>CAF & Patronato EPAS</strong>, con sede in Corso Nunzio Ricco n° 9, 76016 Margherita di Savoia (BT).<br />
                Email: <a href="mailto:patronatoepasmargherita@gmail.com" className="text-blue-900">patronatoepasmargherita@gmail.com</a><br />
                Telefono: 0883 411359
              </p>
            </div>

            {/* Dati Raccolti */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <FileText className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  Dati Raccolti
                </h2>
              </div>
              <div className="text-slate-600 ml-13">
                <p>I dati personali raccolti attraverso questo sito includono:</p>
                <ul className="mt-4 space-y-2">
                  <li><strong>Dati identificativi:</strong> nome, cognome, codice fiscale</li>
                  <li><strong>Dati di contatto:</strong> indirizzo email, numero di telefono, indirizzo</li>
                  <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, pagine visitate</li>
                  <li><strong>Dati relativi alle pratiche:</strong> informazioni necessarie per la compilazione di documenti fiscali e previdenziali</li>
                </ul>
              </div>
            </div>

            {/* Finalità */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <Users className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  Finalità del Trattamento
                </h2>
              </div>
              <div className="text-slate-600 ml-13">
                <p>I dati personali sono trattati per le seguenti finalità:</p>
                <ul className="mt-4 space-y-2">
                  <li>Gestione degli appuntamenti e delle richieste di assistenza</li>
                  <li>Compilazione di dichiarazioni fiscali (730, ISEE, DSU)</li>
                  <li>Gestione pratiche previdenziali e pensionistiche</li>
                  <li>Invio di comunicazioni relative ai servizi richiesti</li>
                  <li>Adempimento di obblighi di legge</li>
                </ul>
              </div>
            </div>

            {/* Base Giuridica */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <Lock className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  Base Giuridica
                </h2>
              </div>
              <div className="text-slate-600 ml-13">
                <p>Il trattamento dei dati si basa su:</p>
                <ul className="mt-4 space-y-2">
                  <li><strong>Consenso:</strong> per l'invio di comunicazioni promozionali</li>
                  <li><strong>Esecuzione contrattuale:</strong> per l'erogazione dei servizi richiesti</li>
                  <li><strong>Obbligo legale:</strong> per gli adempimenti fiscali e normativi</li>
                  <li><strong>Interesse legittimo:</strong> per la sicurezza e il miglioramento dei servizi</li>
                </ul>
              </div>
            </div>

            {/* Conservazione */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <Trash2 className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  Conservazione dei Dati
                </h2>
              </div>
              <p className="text-slate-600 ml-13">
                I dati personali sono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti, e comunque nel rispetto dei termini di conservazione previsti dalla normativa fiscale e previdenziale (generalmente 10 anni dalla chiusura della pratica).
              </p>
            </div>

            {/* Diritti */}
            <div className="mb-12">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
                  <Mail className="w-5 h-5 text-white" />
                </div>
                <h2 className="font-heading text-2xl font-bold text-slate-900 m-0">
                  I Tuoi Diritti
                </h2>
              </div>
              <div className="text-slate-600 ml-13">
                <p>In qualità di interessato, hai il diritto di:</p>
                <ul className="mt-4 space-y-2">
                  <li><strong>Accesso:</strong> ottenere conferma dell'esistenza dei tuoi dati e riceverne copia</li>
                  <li><strong>Rettifica:</strong> richiedere la correzione di dati inesatti</li>
                  <li><strong>Cancellazione:</strong> richiedere la cancellazione dei dati non più necessari</li>
                  <li><strong>Limitazione:</strong> richiedere la limitazione del trattamento</li>
                  <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato</li>
                  <li><strong>Opposizione:</strong> opporti al trattamento per motivi legittimi</li>
                </ul>
                <p className="mt-4">
                  Per esercitare questi diritti, puoi contattarci via email all'indirizzo{" "}
                  <a href="mailto:patronatoepasmargherita@gmail.com" className="text-blue-900">
                    patronatoepasmargherita@gmail.com
                  </a>
                </p>
              </div>
            </div>

            {/* Reclami */}
            <div className="bg-slate-50 rounded-xl p-6 mt-8">
              <h3 className="font-heading text-lg font-bold text-slate-900 mb-3">
                Diritto di Reclamo
              </h3>
              <p className="text-slate-600 text-sm">
                Qualora ritenga che il trattamento dei Suoi dati personali sia effettuato in violazione del Regolamento, ha il diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-slate-200">
              <p className="text-slate-500 text-sm">
                Ultimo aggiornamento: Gennaio 2026
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
